var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.92 5.50203L13.7538 3.66817C14.6708 2.75124 16.5046 2.75124 17.4215 3.66817L18.3385 4.5851C19.2554 5.50203 19.2554 7.3359 18.3385 8.25283L13.7538 12.8375C12.8369 13.7544 11.0031 13.7544 10.0861 12.8375M10.0861 16.5052L8.2523 18.3391C7.33537 19.256 5.50152 19.256 4.5846 18.3391L3.66767 17.4222C2.75075 16.5052 2.75075 14.6714 3.66767 13.7544L8.2523 9.16976C9.16922 8.25283 11.0031 8.25283 11.92 9.16976",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.2c4fd4629ce8f5263cd634d09046c9d4.svg";
export { ForwardRef as ReactComponent };